/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { TypeActe } from '@/types';

/**
 * Valeur du paramètre `typeRegistre` de `GET /registres/listeByType` selon le
 * type d'acte de l'assistant.
 *
 * - `naissance` : `nai` (naissance), `jdn` (jugement déclaratif de naissance),
 *   `jap` (jugement d'adoption plénière) — comportement historique inchangé.
 * - `reconnaissance` : `rec`, flag `rg_rec` déjà présent en base.
 * - `deces` : les cinq registres qui portent un sous-type de décès — `dec`,
 *   `esv` (enfant sans vie), `trans` (transcription), `jda` et `jdd` (jugements
 *   déclaratifs). ⚠️ `trans` n'était pas demandable : la clé manquait côté API,
 *   elle a été ajoutée à `RegistreRepository`.
 */
/**
 * Type de registre des mariages : le flag `rg_mar`, qui couvre les registres de
 * mariage (`rg_typreg` 4) et de projet (9) — cohérent avec les sous-types
 * proposés à la saisie (`M`, `P`, `RVC`).
 *
 * Exporté à part en plus de son entrée au registre : l'étape de saisie du
 * mariage le lit directement, sans avoir à passer par une recherche par type.
 */
export const TYPE_REGISTRE_MARIAGE = 'mar';

const TYPE_REGISTRE_BY_TYPE_ACTE: Partial<Record<TypeActe, string>> = {
  naissance: 'nai,jdn,jap',
  reconnaissance: 'rec',
  deces: 'dec,esv,trans,jda,jdd',
  mariage: TYPE_REGISTRE_MARIAGE,
};

export default TYPE_REGISTRE_BY_TYPE_ACTE;
